import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveCart } from '../../store/actions/cartAction';
import { receiveCart as receiveTruckCart } from '../../store/actions/truckCartAction';

import ProcessBar from './ProcessBar';

import CartItem from '../../models/CartItem';
import TruckCartItem from '../../models/TruckCartItem';
import { UserRoleType } from '../../models/User';

interface ProcessBarContainerProps {
  getCart: Function;
  cart: Array<CartItem>;
  truckCart: Array<TruckCartItem>;
  getTruckCart: Function;
  type: string;
  userRole: UserRoleType;
};

interface ProcessBarContainerState { };

class ProcessBarContainer extends Component<ProcessBarContainerProps, ProcessBarContainerState> {

  componentDidMount() {

    if (this.props.type === 'import') {

      this.props.getCart();
    } else {

      this.props.getTruckCart();
    }
  }

  render() {

    return (
      <ProcessBar 
        cartItems={ this.props.cart.length }
        type={ this.props.type } 
        dropOffItems={ this.props.truckCart.length }
        userRole={ this.props.userRole }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart.items,
    truckCart: state.truckCart.cart
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getCart: () => dispatch(receiveCart()),
    getTruckCart: () => dispatch(receiveTruckCart())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessBarContainer);